<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست روندها
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          target="_blank"
          :href="exportExcel"
      >
        <feather-icon
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label>موضوع روند:</label>
                  <b-form-input
                      v-model="search.title"
                      placeholder="عنوان را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group>
                  <label>متن شامل:</label>
                  <b-form-input
                      v-model="search.description"
                      placeholder="بخشی از متن توضیحات را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col cols="12">
                <small class="text-muted">کاربران</small>
              </b-col>
              <b-col md="4">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      نقش کاربر
                    </label>
                    <v-select
                        v-model="search.roles"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                        :reduce="role => role.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      دسترسی کاربر
                    </label>
                    <v-select
                        v-model="search.permissions"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                        :reduce="permission => permission.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="permissions">
                    کاربران
                  </label>
                  <v-select
                      v-model="search.users"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="receiver => receiver.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" v-if="search.users">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      نوع کاربر
                    </label>
                    <v-select

                        v-model="search.type"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="typeList"
                        :reduce="receiver => receiver.id"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-form-group
                    label="از تاریخ"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.fromDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label="تا تاریخ"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.toDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      :min="search.fromDate"
                      format="YYYY-MM-DD"
                      clearable
                  />

                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">

                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="role">
                      وضعیت روند:
                    </label>
                    <b-form-radio
                        v-model="search.isActive"
                        name="some-radios"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.isActive"
                        name="some-radios"
                        value="1"
                    >
                      فعال
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.isActive"
                        name="some-radios"
                        value="0"
                    >
                      غیرفعال
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
              :fields="fields"
              :items="items"
              striped
              responsive
              show-empty
              empty-text="رکوردی یافت نشد"
          >

            <template #cell(title)="data">
              {{ data.value }}
            </template>
            <template #cell(creator)="data">
              <bdi>{{ data.value.name }}</bdi>
            </template>
            <template #cell(isActive)="data">
              <b-avatar
                  :id="`process-row-${data.item.id}`"
                  button
                  size="32"
                  :variant="data.value ? 'gradient-success': 'gradient-danger'"
                  @click="changeActive(data.item)"
              >
                <feather-icon
                    :icon="data.value ? 'CheckIcon': 'XIcon'"
                />
              </b-avatar>
            </template>

            <template #cell(updatedDate)="data">
              <bdi>{{ data.value }}</bdi>
            </template>

            <template #cell(action)="data">
              <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  :to="{name: 'Processes_Detail', params:{id: data.item.parent && data.item.parent.id ? data.item.parent.id : data.item.id},query:{mainId: data.item.parent && data.item.parent.id ?  data.item.id : undefined}}"
              >
                <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                />
                <span class="align-middle">ویرایش</span>
              </b-button>

            </template>

          </b-table>
        </div>
        <b-pagination
            v-model="currentPage"
            class="mt-2"
            :total-rows="totalRows"
            :per-page="perPage"
        />
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BPagination, BAvatar, BButton,
  VBTooltip, BFormInput, BRow, BFormRadio, BCol, BFormGroup, BCollapse, VBToggle, BForm
} from 'bootstrap-vue'

import ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import {doubleRaf, queryString} from '@/libs/utils'
import {debounce} from '@/libs/debounce'

export default {
  name: 'SaleGroupList',
  components: {
    BCollapse,
    BFormGroup,
    BCol,
    BFormRadio,
    BRow,
    VSelect,
    BFormInput,
    BButton,
    BAvatar,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BPagination,
    BForm
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
    ripple,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'شناسه',
        },
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'creator',
          label: 'مدیر',
        },
        {
          key: 'updatedDate',
          label: 'آخرین بروزرسانی',
        },
        {
          key: 'isActive',
          label: 'وضعیت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      onProgress: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      search: {
        finisherUsers: [],
        roles: [],
      },
      receiversList: [],
      getReceivers: false,
      onExportProgress: false,
      prioritiesList: [],
      rolesList: [],
      permissionList: [],
      typeList: [
        {
          id: 'REQUESTER',
          slug: 'درخواست دهنده',
        }, {
          id: 'STARTER',
          slug: 'شروع کننده',
        }, {
          id: 'ACCEPTOR',
          slug: 'تأیید کننده',
        }, {
          id: 'REVIEWER',
          slug: 'بازنگر',
        }, {
          id: 'FINISHER',
          slug: 'اتمام کننده',
        }],
    }
  },
  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}processes?export-excel=1&${query}`
    },
    titleValue(item, value) {
      console.log(item, value)
      const parentTitle = item.parent ? `(${item.parent.title})` : ''
      return `${value} ${parentTitle}`
    }
  },
  methods: {
    async getProcessesList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true

      this.$http.get('processes', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
          .then(({data}) => {
            if (data.status) {
              this.items = data.processes
              this.currentPage = data.meta.current_page
              this.totalRows = data.meta.total
              this.perPage = data.meta.per_page
            } else {
              this.$bvToast.toast(data.message ?? 'لیست روند ها دریافت نشد', {
                title: 'خطای دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    changeActive(process) {
      const title = !process.isActive ? 'فعال کردن' : 'غیرفعال کردن'
      this.$swal({
        title,
        text: `آیا از ${title} فرایند مطمئن هستید؟`,
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'لغو',
        confirmButtonText: title,
        customClass: {
          confirmButton: `btn btn-${process.isActive ? 'danger' : 'success'} mr-2`,
          cancelButton: 'btn btn-secondary',
        },
      })
          .then(async result => {
            if (result.value) {
              this.$swal({
                title: 'در حال انجام',
                text: 'لطفا تا دریافت نتیجه منتظر بمانید',
                icon: 'info',
                confirmButtonText: 'متوجه شدم',
              })
              await this.$http.put(`processes/${process.id}/activation`, {active: !process.isActive})
                  .then(({data}) => {
                    if (data.status) {
                      this.$swal({
                        title: 'انجام شد',
                        text: 'وضعیت فرایند با موفقیت تغییر کرد',
                        icon: 'success',
                        confirmButtonText: 'متوجه شدم',
                        timer: 2000,
                      })

                      this.items.map(item => {
                        if (item.id === process.id) {
                          item.isActive = !process.isActive
                        }
                        return item
                      })
                    } else {
                      this.$bvToast.toast(data.message, {
                        title: 'خطا',
                        toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                        variant: 'danger',
                      })
                    }
                  })
                  .catch(error => {
                    this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
                      title: 'خطا در دریافت اطلاعات',
                      toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                      variant: 'danger',
                    })
                  })
            }
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getProcessesList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getProcessesList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
    getRoles() {
      this.$http.get('user/roles?paginate=false')
          .then(({data}) => {
            if (data.status) {
              this.rolesList = data.roles
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست نقش ها با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getPermissions() {
      this.$http.get('user/permissions?paginate=false')
          .then(({data}) => {
            this.permissionList = data.permissions
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getRelatedUsers(q) {
      this.$http.get(`user/list?name=${q}`)
          .then(({data}) => {
            this.receiversList = data
            this.getReceivers = true
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),

  },

  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$router.push({
          name: 'Processes_Inbox',
          query: {page: this.currentPage},
        })
        this.items = []
        this.getProcessesList()
      }
    },
    'search.users': function (newValue, oldValue) {
      if (newValue == null) {
        this.search.type = []
      }
    },
  },
  mounted() {
    this.getProcessesList()
    this.getPermissions()
    this.getRoles()
    this.setSearchData()
  },
}
</script>

<style>

</style>
